import { useDocumentTitle } from 'usehooks-ts';
import { useAuth } from 'drycut-auth';
import { useNavigate } from 'react-router';
import { StylistBoard } from 'stylist/components';
import { useScheduledRefresh } from 'controlled-components';

export function Dashboard(): React.ReactNode {
  useDocumentTitle('DRYCUT - Stylist dashboard');

  const navigate = useNavigate();
  const { currentSlug } = useAuth();

  // Refresh the screen at midnight and noon to ensure that the content is always up to date.
  useScheduledRefresh([
    { hour: 20 }, // 8pm, to ensure that the schedule for the next day is always up to date
    { hour: 0 }, // midnight (for new deployments)
  ]);

  if (!currentSlug) {
    navigate('/not-found');
    return null;
  }

  return <StylistBoard slug={currentSlug} />;
}
